module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('p', [_vm._v("Leave me your details and I'll get back to you as soon as I can.")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.successfullySubmitted && !_vm.failedToSubmit) ? _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.triedSubmit && !_vm.$v.name.required
    },
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Your name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.triedSubmit && !(_vm.$v.email.required && _vm.$v.email.email)
    },
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Your email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Your phone number"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "behalf"
    }
  }, [_vm._v("Contacting on behalf of")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.behalf),
      expression: "behalf"
    }],
    attrs: {
      "id": "behalf"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.behalf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Myself")]), _vm._v(" "), _c('option', [_vm._v("My child")]), _vm._v(" "), _c('option', [_vm._v("A school")]), _vm._v(" "), _c('option', [_vm._v("Other")])])])]), _vm._v(" "), (_vm.onChildsBehalf()) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "child"
    }
  }, [_vm._v("Child's name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.child),
      expression: "child"
    }],
    staticClass: "input",
    attrs: {
      "id": "child",
      "type": "text",
      "placeholder": "Your child's name"
    },
    domProps: {
      "value": (_vm.child)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.child = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.onSchoolsBehalf()) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "school"
    }
  }, [_vm._v("School name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    staticClass: "input",
    attrs: {
      "id": "school",
      "type": "text",
      "placeholder": "Name of the school"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    class: {
      'is-danger': _vm.triedSubmit && !_vm.$v.message.required
    },
    attrs: {
      "id": "message",
      "type": "textarea",
      "rows": "4",
      "placeholder": "How can I help?"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.successfullySubmitted) ? _c('div', {
    staticClass: "success-msg"
  }, [_c('p', [_vm._v("Thanks for your message! I'll get back to you as soon as possible.")])]) : _vm._e(), _vm._v(" "), (_vm.failedToSubmit) ? _c('div', {
    staticClass: "failure-msg"
  }, [_c('p', {
    staticClass: "failure-msg-heading"
  }, [_vm._v("Sorry! Something went wrong and we were unable to submit your message.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please see alternative contact options below:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(" - You can email me: contact at " + _vm._s(_vm.domain) + " dot com")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Note: we have seen intermittent issues with this form in the past, please do let me know if you have seen this message to help us investigate further.")])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v(" - Or you can send me a message on twitter: "), _c('a', {
    attrs: {
      "href": "https://twitter.com/ChessCoaches"
    }
  }, [_vm._v("@ChessCoaches")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Phil5.jpg"),
      "alt": "Phil Makepeace British Universities' Chess Championship."
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-611a3be9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 39
// module chunks = 0